import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import instance from './endpoint';
import Loader from '../components/utilComponents/loader';

const isAuthenticated = async () => {
  try {
    const response = await instance.get('/api/v1/auth/isLoggedin');
    if (response.status === 200) {
      return {
        authenticated: true,
        role: response.data.role
      };
    }
    return { authenticated: false };
  } catch (error) {
    return { authenticated: false };
  }
};

const PublicRoute = () => {
  const [authStatus, setAuthStatus] = useState({ authenticated: null, role: null });

  useEffect(() => {
    const checkAuth = async () => {
      const result = await isAuthenticated();
      setAuthStatus(result);
    };

    checkAuth();
  }, []);

  if (authStatus.authenticated === null) {
    return <Loader />; // Show nothing or loader while checking
  }

  if (authStatus.authenticated) {
    switch (authStatus.role) {
      case 'User':
        return <Navigate to="/dashboard" />;
      case 'Admin':
        return <Navigate to="/adminDashboard" />;
      case 'superAdmin':
        return <Navigate to="/superadmindashboard" />;
      default:
        return <Navigate to="/unauthorized" />;
    }
  }

  return <Outlet />;
};

export default PublicRoute;
